import React, { useEffect, useRef } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import {
  Typography,
  LinearProgress
} from '@material-ui/core';
import {
  fetchExploreShapesData
} from 'store/actions';
import { shapeFields } from "components/explore/gmap/shapeFields";

const ShapesDataObject = ({ classes, object, bounds, hasStateInstance, stateInstance, 
  fetchExploreShapesData }) => {
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (!hasStateInstance) return; 
    const { dataFilter, filterRules } = object;
    if (isInitialMount.current && dataFilter && filterRules) {
      isInitialMount.current = false;
      return;
    }
    if (object.visible) {
      fetchExploreShapesData({ objectId: object.id });
    }
    isInitialMount.current = false;
  }, [hasStateInstance, bounds, object.visible]);

  const geoType = stateInstance
    ? stateInstance.requestedGeoType === 'auto'
      ? 'Auto' + (stateInstance.dataGeoType ? ` - ${stateInstance.dataGeoType}` : '')
      : stateInstance.dataGeoType ?? stateInstance.requestedGeoType
    : '';

  const coloringType = stateInstance?.coloringType 
    ? `, ${shapeFields.find(f => f.dataField === stateInstance.coloringType)?.caption ?? stateInstance.coloringType}`
    : ''

  return <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
    <Typography className={classes.textSecondary}>{geoType + coloringType}</Typography>
    <div style={{ flexGrow: 1 }} />
    {stateInstance?.isLoading &&
      <LinearProgress style={{ margin: '2px -8px -3px'}}/>
    }
  </div>;
}
const styles = theme => ({
  textSecondary: {
    fontSize: '.75rem',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    margin: '-3px 0px 0px'
  }
});

const mapStateToProps = ({ exploreMap, exploreShapesData }, ownProps) => {
  const stateInstance = exploreShapesData.shapesDataObjects[ownProps.object.id];
  const hasStateInstance = exploreShapesData.shapesDataObjects[ownProps.object.id] != null;
  return {
    hasStateInstance,
    stateInstance,
    bounds: exploreMap.bounds
  }
};
const mapDispatchToProps = {
  fetchExploreShapesData
};

export default compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(ShapesDataObject);
